var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status == 'success')?_c('div',[_c('ticket-filter',{attrs:{"action":_vm.filterAction}}),_c('div',[(_vm.$can('read', 'ticket'))?_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false)):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }